(function(){
     'use strict';

     angular
        .module('appback')
        .factory('PizarraService', PizarraService);

    PizarraService.$inject = ['$http'];

    function PizarraService($http){

        var service= {
           getPizarra:getPizarra,
           cambiarEstado:cambiarEstado,
           nuevaCarta:nuevaCarta,
           addComentario:addComentario,
           getUsuarioCartas:getUsuarioCartas
        };

        return service;

        function getUsuarioCartas(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pizarra/getusuariocartas', {  ignoreLoadingBar: true, params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function addComentario(item,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }

            var data = $.param({
               carta:JSON.stringify(item)
            });
            $http.post('/backend/pizarra/addcomentario', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function nuevaCarta(carta,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               carta:JSON.stringify(carta)
            });
            $http.post('/backend/pizarra/nuevacarta', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function cambiarEstado(item, estado,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               item:item.id,
               estado:estado
            });
            $http.post('/backend/pizarra/cambiarestado', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
 		function getPizarra(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pizarra/getpizarra', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();